import Vue from 'vue'
import App from './App.vue'

//全局引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 分页组件
import Pagination from "@/components/Pagination";
import TableTextPreview from "@/components/TableTextPreview";

//引入路由
import VueRouter from 'vue-router';
import router from './router';

//引入Vuex
import store from "./store";

//全局引入axios
import axios from "axios";
Vue.prototype.$axios = axios;

//引入全局样式
import './assets/global.css';
//全局引入粒子背景插件（登录界面）
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

//引入echarts
import echarts from "echarts";
import Cookies from 'js-cookie';

Vue.prototype.$echarts = echarts;

//使用路由
Vue.use(VueRouter)

//使用element-ui
Vue.use(ElementUI,{size:'small'});
// eslint-disable-next-line vue/multi-word-component-names
Vue.component('Pagination', Pagination);
Vue.component('TableTextPreview', TableTextPreview);

function clearOrphanDialogMask() {
  if (typeof document === 'undefined') return;
  const dialogWrappers = Array.from(document.querySelectorAll('.el-dialog__wrapper'));
  const hasVisibleDialog = dialogWrappers.some((node) => {
    const style = window.getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden';
  });
  if (!hasVisibleDialog) {
    document.querySelectorAll('.v-modal').forEach((node) => node.remove());
    document.body.classList.remove('el-popup-parent--hidden');
  }
}

function hasAdminToken(token) {
  if (!token) return false;
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload)).isAdmin === true;
  } catch (error) {
    return false;
  }
}

//路由前置导航
  router.beforeEach((to, from, next) => {
    const token = Cookies.get("admin_token");
    const admin = hasAdminToken(token);
    if (!admin && to.path !== '/') {
      // 如果没有token，且用户尝试访问非登录页，重定向到登录页
      next({
        path: '/',
      });
    } else if (admin && to.path === '/') {
      // 如果用户已经登录，且尝试访问登录页，重定向到首页
      next({
        path: '/Home',
      });
    } else {
      // 如果用户有token且访问的不是登录页，或者没有token但访问的是登录页，继续访问目标页面
      next();
    }
  });

router.afterEach(() => {
  Vue.nextTick(() => {
    setTimeout(clearOrphanDialogMask, 0);
    setTimeout(clearOrphanDialogMask, 200);
  });
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
